<template>
    <b-modal
        :id="`modal-form-${modalId}`"
        ref="modal"
        :title="modalTitle"
        size="lg"
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('save')"
        :busy="submitting"
        static
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >
        <b-overlay :show="submitting" opacity="0" class="h-100">
            <b-form @submit.prevent>
                <FormValidator :validator="$v.form.code" form-group v-slot="slotProps" :label="$t('code')" label-cols-sm="3">
                    <b-form-input v-model="form.code" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.name" form-group v-slot="slotProps" :label="$t('name')" label-cols-sm="3">
                    <b-form-input v-model="form.name" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.city" form-group v-slot="slotProps" :label="$t('city')" label-cols-sm="3">
                    <b-form-input v-model="form.city" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.zip" form-group v-slot="slotProps" :label="$t('zip')" label-cols-sm="3">
                    <b-form-input v-model="form.zip" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.address" form-group v-slot="slotProps" :label="$t('address')" label-cols-sm="3">
                    <b-form-input v-model="form.address" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.latitude" form-group v-slot="slotProps" :label="$t('latitude')" label-cols-sm="3">
                    <b-form-input v-model.number="form.latitude" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.longitude" form-group v-slot="slotProps" :label="$t('longitude')" label-cols-sm="3">
                    <b-form-input v-model.number="form.longitude" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.hide" form-group v-slot="slotProps" :label="$t('hide')" label-cols-sm="3">
                    <div class="d-flex align-items-center h-100">
                        <b-form-checkbox v-model="form.hide" :state="slotProps.state" :disabled="submitting" switch />
                    </div>
                </FormValidator>
            </b-form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import ModalFormMixin from '@/mixins/modalFormMixin';
    import FormValidator from '@/components/common/FormValidator.vue';

    export default {
        name: 'ModalForm',
        mixins: [ModalFormMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                campaignId: Number.parseInt(this.$route.params.id),
                modalId: 'campaign-offline-location',
                form: {
                    code: '',
                    name: '',
                    city: '',
                    zip: '',
                    address: '',
                    latitude: null,
                    longitude: null,
                    hide: false,
                },
            };
        },
        computed: {
            createAction() {
                return this.$req('campaigns/OfflineLocation').post;
            },
            updateAction() {
                return this.$req('campaigns/OfflineLocation').patch;
            },
            formValidations() {
                return {
                    form: {
                        code: { required },
                        name: {},
                        city: {},
                        zip: {},
                        address: {},
                        latitude: {},
                        longitude: {},
                        hide: {},
                    },
                };
            },
            apiParams() {
                const apiParams = {
                    requestParams: this.requestParams,
                    urlParams: { campaignId: this.campaignId },
                };
                if (this.action === this.updateAction) apiParams.urlParams.locationId = this.itemId;
                return apiParams;
            },
        },
        methods: {
            refreshData() {
                this.parentComponent.fetchData();
            },
        },
    };
</script>
